(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    /* Marble Bros: when the mouse leaves a product card, return its photo slideshow to the first image. */
  (function () {
    if (window.__mbCardReset) return;
    window.__mbCardReset = true;
    function reset(gallery) {
      var show = gallery.querySelector('slideshow-component');
      if (!show) return;
      try {
        if (typeof show.current === 'number' && show.current === 0) return;
        if (typeof show.select === 'function') {
          show.select(0, undefined, { animate: false });
          return;
        }
      } catch (e) {}
      var slides = show.querySelector('slideshow-slides');
      if (slides) slides.scrollTo({ left: 0, behavior: 'instant' });
    }
    document.addEventListener('pointerleave', function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      var el = event.target;
      if (el && el.classList && el.classList.contains('card-gallery')) reset(el);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
